import { InlineSvg } from 'components/svg';
import { useAuth } from 'features/auth/contexts/auth';
import { useEmployeeDrivingLicenceCheckMutation } from 'features/employees/api/repositories/use-employee-driving-licence-check.mutatuin';
import { UpdateEmployeePersonalDetailsInput } from 'features/employees/api/repositories/use-employee-personal-details-update.mutation';
import { FC } from 'react';
import { UseFormGetValues, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { formatDate } from 'utils/formats';

type Props = {
  setValue: UseFormSetValue<UpdateEmployeePersonalDetailsInput>;
  getValues: UseFormGetValues<UpdateEmployeePersonalDetailsInput>;
  watch: UseFormWatch<UpdateEmployeePersonalDetailsInput>;
};

export const DrivingLicenceCheck: FC<Props> = ({ watch, getValues, setValue }) => {
  const { currentUser } = useAuth();
  const { mutate: drivingLicenceCheckMutation, isLoading } = useEmployeeDrivingLicenceCheckMutation();

  const drivingLicenceCheckHandle = () => {
    const userId = getValues('input.id');
    const postCode = getValues('input.requestBody.postCode');
    const drivingLicenseNumber = getValues('input.requestBody.drivingLicenseNumber');
    const nationalInsuranceNum = getValues('input.requestBody.nationalInsNo');

    drivingLicenceCheckMutation(
      {
        userId: userId as number,
        driverLicenceNum: drivingLicenseNumber ?? '',
        nationalInsuranceNum: nationalInsuranceNum ?? '',
        postCode: postCode ?? ''
      },
      {
        onSuccess: (resp) => {
          setValue('input.requestBody.lastGetDriverInfoDate', new Date().toDateString());
          setValue('input.requestBody.lastGetDriverInfoUserName', currentUser?.userName);
          setValue('input.requestBody.lastGetDriverInfoUserId', currentUser?.userId);
          setValue('input.requestBody.penaltiesAndDisqualifications', resp);
        }
      }
    );
  };

  return (
    <>
      <button
        type="button"
        disabled={isLoading}
        className="btn btn-light-primary me-3"
        data-kt-menu-dismiss="true"
        data-kt-employee-table-filter="reset"
        onClick={drivingLicenceCheckHandle}
      >
        {!isLoading && (
          <>
            <InlineSvg path="/media/icons/custom/parcel-tracking.svg" className="svg-icon-2" />
            Driving Licence Check
          </>
        )}
        {isLoading && (
          <span className="indicator-progress" style={{ display: 'block' }}>
            Please wait... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
          </span>
        )}
      </button>
      {watch('input.requestBody.lastGetDriverInfoUserId') && (
        <div
          style={{
            fontSize: '10px',
            color: '#3B74CE',
            lineHeight: '10px',
            letterSpacing: '-3%',
            fontWeight: 600,
            maxWidth: '220px'
          }}
        >
          <InlineSvg path="/media/icons/custom/check-circle.svg" className="svg-icon-2" />
          Check Success - {formatDate(watch('input.requestBody.lastGetDriverInfoDate') as string)} wo by{' '}
          {watch('input.requestBody.lastGetDriverInfoUserName')}
        </div>
      )}
    </>
  );
};
